import React from 'react';
import { useFlowConfig } from './useFlowConfig';
import { FlowDeviceConfig } from './useFlowConfig';
import { Heater, Siren, ThermometerSnowflake, ThermometerSun, TriangleAlert } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from 'components/ui/accordion';
import FlowInternalHistory from '../components/FlowInternalHistory';
import { getBaseAlertMessageString, getExtendedAlertMessageString } from './helpers';

interface AlertType {
  type: 'freeze' | 'lowLevel' | 'heat';
  message: string;
}

function getAlertTypesWithThresholds(flowConfig: FlowDeviceConfig): AlertType[] {
  const alertTypes: AlertType[] = [];
  if (flowConfig.temp?.alert) {
    alertTypes.push({
      type: 'freeze',
      message: getBaseAlertMessageString(flowConfig, 'tempAlert'),
    });
  }
  if (flowConfig.cmLimit) {
    alertTypes.push({
      type: 'lowLevel',
      message: getBaseAlertMessageString(flowConfig, 'belowLimit'),
    });
  }
  if (flowConfig.temp?.alertMax) {
    alertTypes.push({
      type: 'heat',
      message: getBaseAlertMessageString(flowConfig, 'tempAlertMax'),
    });
  }
  return alertTypes;
}

function getAlertIconByType(type: AlertType['type']) {
  switch (type) {
    case 'freeze':
      return <ThermometerSnowflake className="w-5 h-5 text-yellow-500" />;
    case 'lowLevel':
      return <TriangleAlert className="w-5 h-5 text-yellow-500" />;
    case 'heat':
      return <Heater className="w-5 h-5 text-red-500" />;

    default:
      return <Siren />;
  }
}

export default function LevelConfig({ deviceId }: { deviceId: string }) {
  const { data: flowConfig } = useFlowConfig(deviceId);
  console.log('flowConfig', flowConfig);
  // if no flowConfig, return null
  if (!flowConfig) {
    return null;
  }
  const alertTypes = getAlertTypesWithThresholds(flowConfig);
  if (alertTypes.length === 0) {
    return null;
  }
  return (
    <Accordion type="single" collapsible className="w-full bg-white border rounded-lg">
      <AccordionItem value="alerts" className="border-0 ">
        <AccordionTrigger className="py-3 px-4 hover:no-underline bg-gray-50  hover:bg-gray-50 rounded-lg">
          <div className="flex items-center gap-2">
            <Siren className="w-4 h-4 text-yellow-500" />
            <span className="text-sm font-medium text-gray-700">
              Alarmer slået til ({alertTypes.length})
            </span>
          </div>
        </AccordionTrigger>
        <AccordionContent className="pb-0">
          <ul className="space-y-4 py-2 px-4">
            {alertTypes.map((alertType) => {
              const icon = getAlertIconByType(alertType.type);
              return (
                <li key={alertType.type}>
                  <div className="flex items-center">
                    {icon}
                    <span className="ml-2 text-sm text-gray-600">{alertType.message}</span>
                  </div>
                </li>
              );
            })}
          </ul>
          <FlowInternalHistory configId={flowConfig.id} variant="level" />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
